<template>
    <div class="question-filter-tree" ref="treeLeft">
        <div class="tree-title">
            <div class="title">
                <p :class="{on:treeType == 1}" @click="setTreeType(1)">知识树</p>
                <p 
                  v-if="department != 1 && subjectId == 1 || department == 3 && (subjectId == 2 || subjectId == 4 || subjectId == 5 || subjectId == 6)" 
                  :class="{on:treeType == 2}" 
                  @click="setTreeType(2)"
                >题型树</p>
                <!-- <p class="dsoptionsselect" v-if="!this.filterhide.includes('dsoptions')">
                    <el-cascader
                        ref="departments"
                        v-model="departments"
                        :options="dsoptions"
                        @change="seatchList"
                        size="small"
                        clearable
                        placeholder="学部学科"
                    ></el-cascader>
                </p> -->
                <span class="btn" @click="clearTree">清空</span>
            </div>
        </div>
        <div class="tree-main" :style="{height:treeHeight+'px'}" ref="treeMain">
            <treeItem v-for="(item,index) in treeList" :treeType="treeType" :key="index" :item="item" :root="1" :idList="idList" :check="ischeck" :state="state" :filterText="filterText" @tree-change="treeChange"></treeItem>
        </div>
        <div class="tree-bottom">
            <div class="tree-bottom-title">
                <el-radio-group v-model="treeParams.is_and_set" @change="changetreeParams">
                    <el-radio :label="0">交集</el-radio>
                    <el-radio :label="1">并集</el-radio>
                </el-radio-group>
            </div>
            <div class="tree-bottom-tag">
                <el-tag disable-transitions closable v-for="item in idList" :key="item.id" @close="deltag(item)">{{item.label}}</el-tag>
            </div>
        </div>
    </div>
</template>

<script>
import treeItem from './treeItem'
import { httpRequest } from 'xes-frontend-ui/src/utils/ajax'
export default {
  name: 'xes-question-tree',
  props: ['treeData', 'filterhide', 'secret', 'action', 'department', 'subjectId', 'is_and_set'],
  data () {
    return {
      ischeck: false,
      state: {
        // 显示是否点击了父节点
        parentClick: false,
        // 保存选中背景ID
        bgList: []
      },
      // 存储知识树选中id
      idList: [],
      showHiddenStr: true,
      scrollTop: 0,
      treeHeight: 0,
      subjectNames: '',
      filterText: '',
      treeType: 1, // 题型树
      treeRadio: 1,
      categoryTree: [],
      options: [],
      departments: [],
      treeParams: { // 知识树筛选数据
        is_and_set: this.is_and_set, // 0:交集、1:并集
        cate_tree_id: [],
        knowledge_ids: ''
      }
    }
  },
  computed: {
    treeList () {
      if (this.treeType == 1) {
        return this.treeData
      }
      return this.categoryTree
    }
  },
  watch: {
    subjectId(val) {
      this.setTreeType(1)
    }
  },
  methods: {
    // seatchList(){
    //     console.log(this.departments)
    //     let len=this.departments.length
    //     len==0?this.formdata.department='':this.formdata.department=this.departments[0]
    //     len==0?this.formdata.subject_id='':this.formdata.subject_id=this.departments[1]
    //     this.formdata.grade_ids=''
    //     this.setTreeHeight()
    //     this.getTestList()
    //     this.getlevelsGrades()
    // },
    setTreeHeight () {
      this.$nextTick(() => {
        let tree = this.$refs.treeLeft
        let main = this.$refs.treeMain
        let h = 0

        for (let i = 0; i < tree.children.length; i++) {
          if (tree.children[i] != main) {
            h += tree.children[i].clientHeight
          }
        }
        h = tree.clientHeight - h
        this.treeHeight = h
      })
    },
    // 更改知识树筛选
    changetreeParams () {
      this.$emit('tree-change', this.treeParams)
    },
    treeChange () {
      if (this.treeType == 1) {
        let arr = []
        this.idList.forEach(el => {
          arr.push(el.id)
        })
        this.treeParams.cate_tree_id = []
        this.treeParams.knowledge_ids = arr.join(',')
      } else {
        let arr = []
        this.idList.forEach(el => {
          arr.push(el.id)
        })
        this.treeParams.knowledge_ids = []
        this.treeParams.cate_tree_id = arr.join(',')
      }
      this.setTreeHeight()
      this.changetreeParams()
    },
    getlevelsGrades () {
      this.$emit('get-levels-grades')
    },
    deltag (el) {
      // console.log(this.treeType)
      // console.log(this.idList)
      this.idList.splice(this.idList.indexOf(el), 1)
      if (this.treeType == 1) {
        let arr = []
        this.idList.forEach(el => {
          arr.push(el.id)
        })
        this.treeParams.cate_tree_id = []
        this.treeParams.knowledge_ids = arr.join(',')
      } else {
        let arr = []
        this.idList.forEach(el => {
          arr.push(el.id)
        })
        this.treeParams.knowledge_ids = []
        this.treeParams.cate_tree_id = arr.join(',')
      }
      this.setTreeHeight()
      this.changetreeParams()
    },
    clearData () {
      this.idList = []
      this.treeParams = {
        is_and_set: this.is_and_set,
        cate_tree_id: [],
        knowledge_ids: ''
      }
    },
    setTreeType (type) {
      // console.log(type);

      if (this.treeType == type) return
      this.treeType = type
      this.showHiddenStr = true
      this.idList = []
      if (type == 2) {
        this.getCategorytree()
      }
      this.treeChange()
    },
    getCategorytree () {
      if (!this.action) {
        throw new Error('getCategorytree请求地址为空！')
      }
      let options = {
        method: 'POST',
        params: {secret: this.secret, department: this.department, subject_id: this.subjectId},
        action: this.action
      }
      httpRequest(options)
        .then((res) => {
          if (res.status == 100) {
            this.categoryTree = res.data
          } else {
            this.$emit('status-error', res)
          }
        })
        .catch((err) => {
          this.$emit('ajax-error', err)
        })
    },
    clearTree () {
      this.clearData()
      this.changetreeParams()
    }
  },
  components: {
    treeItem
  },
  mounted () {
    // this.departments = [this.formdata.department, this.formdata.subject_id]
    this.setTreeHeight()
    window.addEventListener('resize',this.setTreeHeight)
  },
  destroyed(){
    window.removeEventListener('resize',this.setTreeHeight)
  }
}
</script>

<style lang="less">
.question-filter-tree .tree-title{
    position: relative;
    .title{
      width: 100%;
      span.btn{
        color: #5A75F6;
        font-size: 14px;
        line-height: 30px;
        margin-left: auto;
        cursor: pointer;
      }
    }
}
.dsoptionsselect{
    width: 100px;
    position: absolute;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// packages/question-tree/src/index.vue